<template>
  <div class="avatars-group">
    <div class="avatars-group__item" v-for="item in items" :key="item.img">
      <v-tooltip location="bottom" :text="item.tooltip">
        <template v-slot:activator="{ props }">
          <VAvatar v-bind="props" color="grey">
            <VImg
              :src="item.img"
              :alt="item.alt"
              v-if="item.img && item.img.length"
            />
            <VIcon icon="mdi-account" v-else></VIcon>
          </VAvatar>
        </template>
      </v-tooltip>
    </div>
  </div>
</template>
<script lang="ts" setup>
interface Props {
  items?: { img: string; alt: string; tooltip: string }[];
}

withDefaults(defineProps<Props>(), {});
</script>

<style lang="scss" scoped>
.avatars-group {
  display: flex;

  &__item {
    margin-left: -10px;
  }
}
</style>
